const AddItemIcon = () => {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 14 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.625 6.625H8.625C7.5204 6.625 6.625 5.72957 6.625 4.625V0.625M6.625 11.125V8.625M6.625 11.125V13.625M6.625 11.125H4.125M6.625 11.125H9.125M12.625 6.45343V14.625C12.625 15.7296 11.7296 16.625 10.625 16.625H2.625C1.52043 16.625 0.625 15.7296 0.625 14.625V2.625C0.625 1.52043 1.52043 0.625 2.625 0.625H6.7966C7.327 0.625 7.8357 0.83571 8.2108 1.21079L12.0392 5.03921C12.4143 5.41429 12.625 5.92299 12.625 6.45343Z"
        stroke="black"
        stroke-width="1.25"
        stroke-linecap="round"
      />
    </svg>
  );
};

export default AddItemIcon;
